// @flow
import * as React from 'react';

import type { Element } from 'react';

import Logo from '@images/logo-letters-white.svg';

const FooterYapitaLogo = (): Element<any> => <Logo alt="logo" width={180} height={36} />;

export default FooterYapitaLogo;
